import axios from 'axios';

export const FETCH_REPLSINDIVIDUAL_BEGIN = 'FETCH_REPLSINDIVIDUAL_BEGIN';
export const FETCH_REPLSINDIVIDUAL_SUCCESS = 'FETCH_REPLSINDIVIDUAL_SUCCESS';
export const FETCH_REPLSINDIVIDUAL_FAILURE = 'FETCH_REPLSINDIVIDUAL_FAILURE';

export const fetchREPLsIndividualBegin = () => ({
    type: FETCH_REPLSINDIVIDUAL_BEGIN
});

export const fetchREPLsIndividualSuccess = REPLsIndividual => ({
    type: FETCH_REPLSINDIVIDUAL_SUCCESS,
    payload: REPLsIndividual
});

export const fetchREPLsIndividualFailure = error => ({
    type: FETCH_REPLSINDIVIDUAL_FAILURE,
    payload: { error }
});

export const getREPLsIndividual = (webappurl, accessToken) => {

    return dispatch => {
        dispatch(fetchREPLsIndividualBegin());

        const data = {
        };

        const options = {
            headers: {
                'Authorization': "Bearer " + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return axios.post(webappurl + "/api/myCASA/Portal/GetREPLSubmissionsIndividual/v1", data, options)
            .then(responseArr => {
                return dispatch(fetchREPLsIndividualSuccess(responseArr.data.value));
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status === 200) {
                        return dispatch(fetchREPLsIndividualFailure("System error RePLI.1a: " + error.request.statusText));
                    }
                    else {
                        if (error.response.data !== "") {
                            return dispatch(fetchREPLsIndividualFailure("System error RePLI.1e: " + error.response.data.value.errorMessage));
                        }
                        return dispatch(fetchREPLsIndividualFailure("System error RePLI.1d: " + error.request.statusText));
                    }
                } else if (error.request) {
                    return dispatch(fetchREPLsIndividualFailure("System error RePLI.1b: " + error.request.statusText));
                } else {
                    return dispatch(fetchREPLsIndividualFailure("System error RePLI.1c: " + error));
                }                                          
            });
    };
}